// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-main > .aiiif-a {
    position: relative;
}

.aiiif-navigation {
    background-color: #EDECED;
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    position: absolute;
    top: 0;
    bottom: 0;
    overflow-y: auto;
}

.aiiif-navigation-bar {
    position: sticky;
    top: 0;
    background-color: gray;
    opacity: 0.7;
}

.aiiif-navigation-bar > svg {
    margin: 4px;
    cursor: pointer;
}

.aiiif-search {
    padding: 6px 12px;
    width: 100%;
}

.aiiif-search-result-item {
    line-height: 1.6rem;
    cursor: pointer;
    text-align: left;
    margin: 10px 0;
}

.aiiif-search-result-item > p {
    margin: 10px 0;
}

.aiiif-search-input {
    margin-bottom: 12px !important;
}

.aiiif-search-badge {
    font-size: 0.8rem;
    background-color: #ffff00;
    border-radius: 20px;
    padding: 2px 6px;
    margin-right: 4px;
}
.aiiif-search-result-item-active .aiiif-search-badge {
    background-color: #7CD6FA;
}

.aiiif-highlight {
    background-color: #ffff00;
    opacity: 0.2;
}

.aiiif-highlight.active {
    background-color: #7CD6FA;
    border: 2px solid #064e6c;
}

`, "",{"version":3,"sources":["webpack://./src/infoBar/tabs/search.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B","sourcesContent":[".aiiif-main > .aiiif-a {\n    position: relative;\n}\n\n.aiiif-navigation {\n    background-color: #EDECED;\n    width: 100%;\n    display: flex;\n    align-items: stretch;\n    flex-direction: column;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    overflow-y: auto;\n}\n\n.aiiif-navigation-bar {\n    position: sticky;\n    top: 0;\n    background-color: gray;\n    opacity: 0.7;\n}\n\n.aiiif-navigation-bar > svg {\n    margin: 4px;\n    cursor: pointer;\n}\n\n.aiiif-search {\n    padding: 6px 12px;\n    width: 100%;\n}\n\n.aiiif-search-result-item {\n    line-height: 1.6rem;\n    cursor: pointer;\n    text-align: left;\n    margin: 10px 0;\n}\n\n.aiiif-search-result-item > p {\n    margin: 10px 0;\n}\n\n.aiiif-search-input {\n    margin-bottom: 12px !important;\n}\n\n.aiiif-search-badge {\n    font-size: 0.8rem;\n    background-color: #ffff00;\n    border-radius: 20px;\n    padding: 2px 6px;\n    margin-right: 4px;\n}\n.aiiif-search-result-item-active .aiiif-search-badge {\n    background-color: #7CD6FA;\n}\n\n.aiiif-highlight {\n    background-color: #ffff00;\n    opacity: 0.2;\n}\n\n.aiiif-highlight.active {\n    background-color: #7CD6FA;\n    border: 2px solid #064e6c;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
